import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { boards } from "@/mocks/boards";
import TopicRow from "@/components/feature/TopicRow";

export default function HotTopics() {
  const ranked = [...topics].sort((a, b) => b.views - a.views);
  const champion = ranked[0];
  const rankList = ranked.slice(1, 8);
  const totalToday = boards.reduce((sum, board) => sum + board.todayPosts, 0);

  return (
    <section id="hot" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="text-xs font-medium tracking-widest text-accent-600">TRENDING</span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">热帖推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">
            按近期互动、点赞与回帖量动态排序，正在被刷屏的讨论都在这儿。
          </p>
        </div>
        <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs text-accent-800">
          <i className="ri-refresh-line" />
          每 10 分钟更新一次
        </span>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="rounded-lg border border-background-200 bg-background-50 px-5">
            {rankList.map((topic, index) => (
              <TopicRow key={topic.id} topic={topic} rank={index + 2} />
            ))}
          </div>
        </div>

        <div className="space-y-6 lg:col-span-4">
          <article className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-48 w-full overflow-hidden">
              <img
                src={champion.cover}
                alt={`${champion.title} 热度榜首配图`}
                title={`${champion.title} - 瓜田社区热帖推荐`}
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                <i className="ri-trophy-line" />
                今日瓜王
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-base font-semibold leading-snug text-foreground-950">
                <Link to={`/topic/${champion.id}`} className="transition-colors hover:text-primary-700">
                  {champion.title}
                </Link>
              </h3>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line" />
                  {champion.views} 热度
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-smile-2-line" />
                  {champion.replies} 回帖
                </span>
              </div>
            </div>
          </article>

          <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
            <h3 className="flex items-center gap-1.5 text-sm font-semibold text-foreground-950">
              <i className="ri-bar-chart-2-line text-primary-600" />
              板块热度榜 · 今日 +{totalToday.toLocaleString()} 帖
            </h3>
            <ul className="mt-4 space-y-3.5">
              {[...boards]
                .sort((a, b) => b.todayPosts - a.todayPosts)
                .slice(0, 5)
                .map((board) => {
                  const percent = Math.round((board.todayPosts / 1340) * 100);
                  return (
                    <li key={board.id}>
                      <div className="flex items-center justify-between text-xs text-foreground-600">
                        <Link
                          to={`/topics?board=${board.id}`}
                          className="flex items-center gap-1.5 transition-colors hover:text-primary-700"
                        >
                          <i className={board.icon} />
                          {board.name}
                        </Link>
                        <span>{board.todayPosts}</span>
                      </div>
                      <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-300">
                        <div
                          className="h-full rounded-full bg-primary-500"
                          style={{ width: `${percent}%` }}
                        />
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}